import { gql } from '@apollo/client';

export const QUERY = gql`
  query Email($organizationId: Int!) {
    emails(organizationId: $organizationId) {
      id
      body
      subject
      isDraft
      emailRecipients {
        divisionId
        divisionName
        seasonId
        seasonName
        programId
        programName
      }
      senderName
      sentAt
    }
  }
`;
